import { isDate, isBefore } from "date-fns";
import {utcToZonedTime} from "date-fns-tz";
import { isWithinTime } from "../../utilities";

export const campaignEditValidators = {
  sms_content: {
    enabled: (values) => values.sms_send === true,
    assertions: [
      (value) => ({
        valid: !!value,
        error: 'sms content cannot be empty'
      })
    ]
  },
  push_content: {
    enabled: (values) => values.push_send === true,
    assertions: [
      (value) => ({
        valid: !!value,
        error: 'native app content cannot be empty'
      })
    ]
  },
  push_notification_content: {
    enabled: (values) => values.push_send === true,
    assertions: [
      (value) => ({
        valid: !!value,
        error: 'native app notification content cannot be empty'
      }),
      (value) => ({
        valid: !!value && value.length <= 240,
        error: 'native app notification content cannot be longer than 240 symbols'
      })
    ]
  },
  sms_send: {
    include: ['sms_content', 'email_send', 'template_id', 'push_send'],
    assertions: [
      (value, { email_send, push_send }) => ({
        valid: value === true || (value === false && (email_send === true || push_send === true)),
        error: 'at least one message type has to be selected'
      })
    ]
  },
  push_send: {
    include: ['push_content', 'push_notification_content', 'sms_send', 'email_send', "sending_method"],
    assertions: [
      (value, { sms_send, email_send }) => ({
        valid: value === true || (value === false && (sms_send === true || email_send === true)),
        error: 'at least one message type has to be selected'
      }),
      {
        enabled: ({ sending_method, email_send }) => sending_method === "push_notification_only" && email_send === false,
        test: (value) => {
          return {
            valid: value,
            error: "native app message or email has to be selected"
          }
        }
      },
    ]
  },
  email_send: {
    include: ['email_subject', 'has_email_template', 'sms_send', 'push_send'],
    assertions: [
      (value, { sms_send, push_send }) => ({
        valid: value === true || (value === false && (sms_send === true || push_send === true)),
        error: 'at least one message type has to be selected'
      })
    ]
  },
  email_subject: {
    enabled: (values) => values.email_send === true,
    assertions: [
      (value) => ({
        valid: !!value && value.length > 0,
        error: 'email subject cannot be empty '
      })
    ]
  },
  has_email_template: {
    enabled: (values) => values.email_send === true,
    assertions: [
      (value) => ({
        valid: value == true,
        error: 'email template needs to be created'
      })
    ]
  },
  template_id: {
    enabled: ({ sms_send, classicCampaignsEnabled }) => sms_send === true && classicCampaignsEnabled !== true,
    assertions: [
      (value) => ({
        valid: !!value,
        error: 'must choose a notification message'
      })
    ]
  },
  schedulerRange: {
    include: ['send_at_local'],
    assertions: []
  },
  send_now: {
    include: ['send_at_local'],
    assertions: [
      (value, { schedulerRange }, { currentMerchant }) => {
        const currentMerchantTime = utcToZonedTime(new Date(), currentMerchant.merchant_time_zone);

        return {
          valid: value === false || !schedulerRange || !schedulerRange.time.min || isWithinTime(schedulerRange.time.min, schedulerRange.time.max, currentMerchantTime),
          error: 'current merchant time is outside of ad\s time range'
        }
      }
    ]
  },
  send_at_local: {
    include: ['send_now'],
    enabled: ({ send_now }) => send_now === false,
    assertions: [
      (value) => ({
        valid: isDate(value),
        error: 'must schedule a send time'
      }),
      (value, { schedulerRange }) => {
        return {
          valid: !schedulerRange || !schedulerRange.time.min || isWithinTime(schedulerRange.time.min, schedulerRange.time.max, value),
          error: 'send time is outside of ad\'s time range'
        };
      },
      (value, { reward }, {currentMerchant}) => {
        const error =  'send time is after extension expiration date';
        if(!reward?.expiry_days) {
          return {
            valid: true,
            error
          }
        }
        const expiry_days_local = utcToZonedTime(new Date(reward.expiry_days), currentMerchant.merchant_time_zone);
        return {
          valid: isBefore(new Date(value), expiry_days_local),
          error
        }

      }
    ]
  },
  reward: {
    assertions: [
      {
        enabled: ({ _type, extension_type }) => _type === 1 || extension_type === 1,
        test: (value) => {
          return {
            valid: !value || value.expiration_date,
            error: "must include an expiration date with digital voucher"
          }
        }
      }, {
        enabled: ({ _type, extension_type }) => _type === 5 || extension_type === 5,
        test: (value) => {
          return {
            valid: !value || value.expiration_date,
            error: "must include an expiration date with bonus points"
          }
        }
      }
    ]
  }
};
